/*
 * Helper class for Actis Reporting.
 *
 */
import { getUserRole } from "@utils/utilities";
export class ActisReporting {
  constructor(category) {
    this.category = category;
    this.push = this.push.bind(this);
  }
  // allow this to pass a event category
  push(obj) {
    if (window.pushEvent) {
      this.binder = this.__proto__.binder;
      const userName = this.binder.firstName + " ";
      window.pushEvent(
        {
          ...obj,
          activityMeta: obj.activityMeta,
          category: this.category,
          userId: this.binder.userId || "",
          firstName: this.binder.firstName || "",
          lastName: this.binder.lastName || "",
          email: this.binder.email?.toLowerCase() || "",
          companyName: this.binder.companyName || "",
          orgId: this.binder.orgId || "",
          userType: getUserRole(this.binder.roles) || "",
        },
        "mercury-firehose"
      );
    }
  }
}

export const ACTIS_REPORTING = {
  BINDER: null,
  GARTNER_LOGO: new ActisReporting("Gartner Logo Click"),
  INSIGHTS_PLATFORM: new ActisReporting("Insights platform click"),
  USER_ACTION: new ActisReporting("Intercom - header click"),
};
